import classnames from 'clsx';
import React, { Component, createRef, ReactElement } from 'react';

import styles from './Switch.css';

interface Props {
    checked: boolean;
    name: string;
    value?: string;
    disabled?: boolean;
    isAwaysBlue?: boolean;
    onChange?: Function | null;
    theme?: '' | 'rounded' | 'big';
}

interface State {
    showAdditionals: boolean;
}

export class Switch extends Component<Props, State> {
    private input = createRef<HTMLInputElement>();

    onClick = (e) => {
        const { disabled, onChange = null } = this.props;

        if (disabled || !onChange) {
            return;
        }

        e.stopPropagation();

        onChange();
    };

    public render(): ReactElement {
        const { name, value, disabled, checked, theme, isAwaysBlue = false } = this.props;

        const className = classnames({
            [styles.base]: true,
            [styles.base_disabled]: disabled,
            [styles[`base_${theme}`]]: !!theme,
            [styles.base_checked]: checked,
            [styles.base_blue]: isAwaysBlue,
        });

        return (
            <div className={className} onClick={this.onClick}>
                <input
                    className={styles.input}
                    ref={this.input}
                    type="checkbox"
                    name={name}
                    value={value}
                    disabled={disabled}
                    checked={checked}
                    onChange={this.onClick}
                />
                <div className={styles.label}>
                    <div className={styles.slider} />
                </div>
            </div>
        );
    }
}
